<template>
  <div class="numbers_filter">
    <div class="flex flex-between">
      <h5 class="numbers_filter--label">{{ label }}</h5>

      <div class="numbers_filter--select_all">
        <button-link
          @click="selectAll"
          class="numbers_filter--select_all--button"
        >select all
        </button-link>
        <button-link
          @click="deselectAll"
          class="numbers_filter--select_all--button"
        >deselect all
        </button-link>
      </div>
    </div>

    <div class="numbers_filter--list">
      <b-checkbox
        v-for="option in options"
        :key="option.id"
        v-model="filterValue"
        :native-value="option.id"
        @input="handleInput"
        size="is-small"
      >
        {{ option.label }}: {{ $utils.formatNumber(option.number) }}
      </b-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilterPhoneNumbersMultiple",
  props: {
    label: {
      type: String,
      default: "Phone Numbers"
    },
    storeModule: {
      type: String,
      required: true
    },
    filterName: {
      type: String,
      required: true
    },
    initialValue: Number,
  },
  created() {
    if (this.initialValue) {
      this.commitNumbers([this.initialValue])
    }

    this.handleInput()
  },
  computed: {
    filterValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].phoneNumbers;
      },
      set(value) {
        this.commitNumbers(value);
      }
    },
    options() {
      return this.$store.getters.integrationPhoneNumbers
    },
    text() {
      if (!this.filterValue.length) return null

      let phoneNumberLabels = []
      this.filterValue.forEach(numberId => {
        const phoneNumber = this.options.find(number => {
          return number.id === numberId
        })

        if (phoneNumber) {
          phoneNumberLabels.push(`${phoneNumber.label}: ${phoneNumber.number}`)
        }
      })

      return phoneNumberLabels.join(", ")
    },
  },
  methods: {
    selectAll() {
      this.filterValue = this.options.map(number => number.id)
      this.handleInput()
    },
    deselectAll() {
      this.filterValue = []
      this.handleInput()
    },
    commitNumbers(ids) {
      this.$store.commit(this.storeModule + "/setOneFilter", [
        this.filterName,
        "phoneNumbers",
        ids
      ])
    },
    handleInput() {
      this.$emit("change", this.text)
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.numbers_filter {

  &--label {
    font-size: 0.875rem;
    font-weight: normal;
  }

  &--select_all {
    display: flex;

    &--button {
      margin-left: 10px;
    }
  }

  &--list {
    padding: 8px 4px 0;
  }
}

::v-deep .b-checkbox.checkbox {
  display: flex !important;
  margin-bottom: 4px;
}
</style>
